/** Staff allowed as ticket assignees (matches API allowlist; stored value is lowercase email). */
export const TICKET_STAFF_ASSIGNEES = [
  { email: "ben@simplecrumb.com", label: "Ben" },
  { email: "josh@simplecrumb.com", label: "Josh" },
  { email: "liam.wakely@simplecrumb.com", label: "Liam Wakely" },
  { email: "reef.lakin@simplecrumb.com", label: "Reef Lakin" },
  { email: "ollie.bradford@recyclingsoftware.co.uk", label: "Ollie Bradford" },
] as const;

const byEmailLower = new Map(
  TICKET_STAFF_ASSIGNEES.map((s) => [s.email.toLowerCase(), s] as const),
);

export function isStaffAssigneeEmail(email: string | null | undefined): boolean {
  if (!email?.trim()) return false;
  return byEmailLower.has(email.trim().toLowerCase());
}

/** Returns canonical email from the list, or undefined if not a staff assignee. */
export function canonicalStaffEmail(email: string | null | undefined): string | undefined {
  if (!email?.trim()) return undefined;
  return byEmailLower.get(email.trim().toLowerCase())?.email;
}

export function ticketAssigneeLabel(stored: string | null | undefined): string {
  if (!stored?.trim()) return "Unassigned";
  const row = byEmailLower.get(stored.trim().toLowerCase());
  if (row) return row.label;
  return stored.trim();
}

/** True when the ticket assignee matches this signed-in staff email (allowlist canonical form). */
export function isTicketAssignedToUser(
  ticket: { assignedToUserId?: string },
  userEmail: string | null | undefined,
): boolean {
  const mine = canonicalStaffEmail(userEmail ?? undefined);
  if (!mine) return false;
  const raw = ticket.assignedToUserId?.trim();
  if (!raw) return false;
  return raw.toLowerCase() === mine.toLowerCase();
}
